(function(){
    'use strict';
    angular.module('app').controller('AccountingCaseDetailsController', AccountingCaseDetailsController);
    AccountingCaseDetailsController.$inject = [
        'AccountingService',
        'AccountingCaseDetailsTable',
        '$routeParams',
        'toastr'
    ];

    function AccountingCaseDetailsController(
        AccountingService,
        AccountingCaseDetailsTable,
        $routeParams,
        toastr
    ){
        const vm = this;
        vm.isFetching = true;

        init();
        function init(){
            loadAndDiscrepancyAndDisputeDetails();
        }

        function loadAndDiscrepancyAndDisputeDetails(){
            vm.isFetching = true;
            AccountingService.CaseManagement.getCaseDetails(data=>{
                vm.isFetching = false;
                vm.disputeAndDiscrepancyDetails = data;
                vm.accountingCaseDetailsTable = new AccountingCaseDetailsTable(data.cases, angular.getObjVal(data, 'shipment.id')).tableData;
                vm.isFetching = false;
            }, error => {
                toastr.error(error.message, "Error");
                vm.isFetching = false;
            }, $routeParams.id);
        } 
    }
})()


// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountingCaseDetailsController.js